import { Skeleton } from "@mui/material";

export const AtTabsSkeleton = () => {
  return (
    <div className="flex h-16 pl-12 border-solid border-b-2 border-surface-75">
      {Array.from({ length: 3 }).map((_, index) => (
        <div
          key={index}
          className="flex flex-col"
          style={{ width: "144px", height: "64px" }}
        >
          <div className="flex-1 flex items-center justify-center">
            <Skeleton variant="text" width={90} height={24} />
          </div>
          <Skeleton
            variant="rectangular"
            width={144}
            height={4}
            className={`${index > 0 ? "!bg-transparent" : "!bg-current"}`}
          />
        </div>
      ))}
    </div>
  );
};
